import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';

export const StyledEvergreenDynamic = styled.div`
  box-sizing: border-box;
  font-family: var(--font-family), Arial;
  width: 100%;
  min-height: 100%;
  position: relative;
  border-radius: 7px;
  background: ${(props: any) =>
    props.backgroundSrc
      ? `url("${props.backgroundSrc}")`
      : createGradientOrSolid(props.backgroundColor)};
  padding: 32px 8px 8px 8px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  box-shadow: 0px 4px 4px 0px rgba(255, 255, 255, 0.25) inset;

  .evergreen-dynamic-bundle {
    &__sale-badge {
      position: absolute;
      top: -2px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 20px;
      min-width: 80px;

      &__text {
        width: 50%;
        max-width: 50%;
        position: absolute;
        font-size: 12px;
        font-weight: 600;
        color: white;
        margin: unset;
        top: 2px;
        text-shadow: 0px 0px 2px #2b2b2b;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    &__products-container {
      position: relative;
      top: -10px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      justify-content: center;
      width: 100%;
      flex-grow: 1;
    }
  }
` as any;
